import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import { FaHeart, FaCamera, FaMapMarkerAlt, FaGift, FaMobileAlt, FaEnvelope, FaUsers, FaClock, FaCode, FaRocket } from 'react-icons/fa';

const WebBodasPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-pymes", text: "Página web barata para PYMES" },
    { url: "/servicios/diseno-web-autonomos", text: "Página web barata para autónomos" },
    { url: "/servicios/diseno-web-empresas", text: "Página web barata para empresas" },
    { url: "/servicios/landing-pages", text: "Landing pages económicas" },
    { url: "/precios", text: "Ver todos nuestros precios" },
    { url: "/proceso", text: "Conoce nuestro proceso de trabajo" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Ahorra más de 800€ en invitaciones",
      description: "Una web para bodas cuesta menos que imprimir y enviar invitaciones físicas. El precio medio de invitaciones en papel + envío es de 12€ por invitado. Con 80 invitados ahorras más de 800€."
    },
    {
      title: "Confirmaciones automáticas sin llamadas",
      description: "Olvídate de llamar uno por uno para confirmar asistencia. Los invitados responden directamente en la web y tú recibes las confirmaciones organizadas en tiempo real."
    },
    {
      title: "Menos estrés y mejor organización",
      description: "Toda la información centralizada en un solo lugar: ubicación del evento, horarios, menús, lista de regalos, alojamientos cercanos. Reduce dudas y llamadas de última hora."
    },
    {
      title: "Ahorra tiempo en resolver dudas",
      description: "Las 20 preguntas más frecuentes de los invitados, respondidas en la web. Cada minuto que no dedicas a contestar llamadas es tiempo que puedes disfrutar preparando tu boda."
    },
    {
      title: "Recuerdos digitales centralizados",
      description: "Tus invitados pueden subir las fotos que tomen durante la celebración. Consigues cientos de fotos extras además de las del fotógrafo profesional, sin coste adicional."
    },
    {
      title: "Acceso permanente a los recuerdos",
      description: "La web queda activa el tiempo que quieras para revivir momentos. Un álbum digital que no se deteriora y podéis compartir con quien queráis en el futuro."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaHeart />,
      title: "Diseño personalizado con vuestra historia",
      description: "Adaptamos el diseño a vuestro estilo y colores de boda. Incluimos vuestra historia como pareja y cuenta atrás hasta el gran día."
    },
    {
      icon: <FaMobileAlt />,
      title: "Perfecta en móviles, donde más se usa",
      description: "El 90% de invitados consultará la web desde el móvil. Garantizamos que se vea perfecta en cualquier dispositivo para una experiencia impecable."
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Ubicaciones exactas con Google Maps",
      description: "Mapas interactivos con indicaciones precisas para llegar a ceremonia, celebración y alojamientos. Reduce los invitados perdidos o llegando tarde."
    },
    {
      icon: <FaEnvelope />,
      title: "Sistema de confirmación de asistencia",
      description: "Formulario sencillo para que los invitados confirmen asistencia, seleccionen menú y añadan comentarios. Todos los datos organizados para ti."
    },
    {
      icon: <FaCamera />,
      title: "Galería para compartir fotos",
      description: "Tus invitados pueden subir sus fotos directamente a la web. Todas las imágenes del evento centralizadas en un solo lugar, organizadas y descargables."
    },
    {
      icon: <FaGift />,
      title: "Lista de boda digital integrada",
      description: "Lista de regalos o enlace a cuentas bancarias para aportaciones. Evita regalos duplicados y facilita la organización para tus invitados."
    }
  ];
  
  // Planes de precios adaptados
  const plans = [
    {
      title: 'Web de Boda Básica',
      price: 99,
      period: 'pago único',
      description: 'Para parejas que buscan una solución sencilla con la información esencial.',
      features: [
        { text: 'Diseño responsive adaptado a móviles', included: true },
        { text: 'Página de inicio con cuenta atrás', included: true },
        { text: 'Historia de la pareja', included: true },
        { text: 'Ubicación con Google Maps', included: true },
        { text: 'Información de la ceremonia y banquete', included: true },
        { text: 'Galería de fotos básica', included: true },
        { text: 'Formulario de confirmación', included: true },
        { text: '1 año de alojamiento web incluido', included: true },
        { text: 'Galería colaborativa de invitados', included: false },
        { text: 'Lista de regalos/boda digital', included: false },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=boda-basica',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web de Boda Premium',
      price: 149,
      period: 'pago único',
      description: 'La más elegida. Web completa con todas las funciones para una boda perfecta.',
      features: [
        { text: 'Diseño premium 100% personalizado', included: true },
        { text: 'Página de inicio con cuenta atrás', included: true },
        { text: 'Historia de la pareja con timeline', included: true },
        { text: 'Múltiples ubicaciones con mapas', included: true },
        { text: 'Información detallada del evento', included: true },
        { text: 'Sugerencias de alojamiento cercano', included: true },
        { text: 'Confirmación de asistencia con opciones de menú', included: true },
        { text: 'Galería colaborativa de invitados', included: true },
        { text: 'Lista de boda digital integrada', included: true },
        { text: '2 años de alojamiento web incluido', included: true },
      ],
      isPopular: true,
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=boda-premium',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web de Boda Deluxe',
      price: 249,
      period: 'pago único',
      description: 'Experiencia exclusiva con características avanzadas y diseño de lujo.',
      features: [
        { text: 'Diseño exclusivo con animaciones', included: true },
        { text: 'Inicio personalizado con vídeo', included: true },
        { text: 'Historia interactiva multimedia', included: true },
        { text: 'Sistema de itinerario personalizado', included: true },
        { text: 'RSVP avanzado con gestión de mesas', included: true },
        { text: 'Playlist colaborativa para la fiesta', included: true },
        { text: 'Galería profesional con filtros', included: true },
        { text: 'Gestión completa de lista de regalos', included: true },
        { text: 'Libro de firmas digital para invitados', included: true },
        { text: '5 años de alojamiento web incluido', included: true },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=boda-deluxe',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Consulta y diseño personalizado",
      description: "Conocemos vuestros gustos y preferencias. Elegimos colores, estilo y contenido para crear un diseño único que refleje vuestra personalidad como pareja.",
      icon: <FaUsers />
    },
    {
      number: 2,
      title: "Desarrollo en tiempo récord",
      description: "Creamos vuestra web en 3-5 días laborables con todos los contenidos y funcionalidades. Os enviamos una versión previa para revisar y ajustar cualquier detalle.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y asistencia",
      description: "Activamos la web y os enviamos una guía sencilla para compartirla con invitados. Ofrecemos soporte antes y durante la boda para resolver cualquier duda.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Precio transparente sin costes ocultos",
      us: true,
      others: false
    },
    {
      label: "Diseño 100% personalizado (no plantillas)",
      us: true,
      others: false
    },
    {
      label: "Desarrollo en 3-5 días laborables",
      us: true,
      others: false
    },
    {
      label: "Soporte técnico directo por WhatsApp",
      us: true,
      others: false
    },
    {
      label: "Sin límite de invitados ni visitas",
      us: true,
      others: false
    },
    {
      label: "Dominio personalizado incluido",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Estábamos agobiados con tantos preparativos y la web fue lo más práctico y económico. Ahorramos en invitaciones de papel y tiempo en llamadas. Todos los invitados nos felicitaron por lo fácil que era confirmar y encontrar la información. Las fotos que subieron nuestros amigos fueron un tesoro inesperado. Sin duda, una de las mejores decisiones que tomamos para nuestra boda.",
    author: "Elena y Carlos",
    position: "Novios",
    company: "Boda en junio 2023",
    avatar: "/servicios/testimonios/boda.webp"
  };
  
  // FAQs específicas para web de bodas
  const faqs = [
    {
      question: "¿Por qué es mejor una web de boda que invitaciones tradicionales?",
      answer: "Una web de boda ofrece múltiples ventajas frente a las invitaciones tradicionales: 1) Ahorro económico significativo (entre 500€-1200€ para bodas de 70-100 invitados); 2) Información actualizable en tiempo real (si hay cambios de última hora, todos los invitados reciben la información actualizada); 3) Confirmación de asistencia automatizada con opciones de menú, alergias e intolerancias; 4) Toda la información necesaria accesible siempre (ubicación, horarios, código de vestimenta, etc.); 5) Respeto al medio ambiente eliminando el papel; 6) Posibilidad de incluir mucho más contenido como vuestra historia, fotos de preboda o recomendaciones de alojamiento; 7) Espacio para compartir fotos durante y después del evento; 8) Acceso permanente a los recuerdos. La experiencia de nuestros clientes demuestra que incluso invitados de edad avanzada se adaptan perfectamente a este formato moderno y práctico.",
      category: "Ventajas"
    },
    {
      question: "¿Cuánto tiempo antes de la boda debería contratar la web?",
      answer: "Lo ideal es contratar la web de boda con al menos 3-4 meses de antelación. Esto permite: 1) Incluir la dirección web en las invitaciones físicas (si decides enviar alguna); 2) Dar tiempo suficiente a los invitados para confirmar su asistencia, seleccionar menú y organizar su alojamiento; 3) Resolver dudas frecuentes sin llamadas de última hora. Sin embargo, podemos desarrollar tu web en un plazo muy corto si es necesario (mínimo una semana). Hemos creado webs para parejas con solo 3 semanas de antelación a su boda y han funcionado perfectamente. El desarrollo en sí solo requiere 3-5 días laborables una vez tenemos toda la información necesaria. Una vez creada, la web se puede actualizar en cualquier momento hasta el día de la boda, añadiendo información adicional según avanza la organización del evento.",
      category: "Plazos"
    },
    {
      question: "¿Qué información necesito proporcionar para crear la web?",
      answer: "Para crear tu web de boda necesitamos la siguiente información básica: 1) Nombres completos de los novios; 2) Fecha, hora y ubicación exacta de la ceremonia; 3) Datos del lugar de celebración del banquete; 4) Algunas fotos de la pareja (mínimo 5-8 de buena calidad); 5) Un breve texto sobre vuestra historia (opcional, podemos ayudaros a redactarlo); 6) Preferencias de estilo y colores para el diseño; 7) Información sobre el registro de regalos si lo tenéis. Para algunas funcionalidades adicionales podríamos necesitar: menú del banquete, recomendaciones de alojamiento, información sobre transporte o aparcamiento, y cualquier detalle especial que queráis comunicar a vuestros invitados. Te proporcionamos un formulario sencillo para que puedas enviarnos toda esta información estructurada de forma fácil y rápida. No te preocupes si no tienes todos los detalles al principio, podemos ir actualizando la web a medida que confirmes más aspectos de tu boda.",
      category: "Proceso"
    },
    {
      question: "¿Cómo funciona la confirmación de asistencia?",
      answer: "El sistema de confirmación de asistencia (RSVP) funciona de manera muy intuitiva: 1) Los invitados acceden a la web y van a la sección de confirmación; 2) Introducen su nombre y apellidos; 3) Indican si asistirán, cuántas personas vendrán (puedes limitar este número), seleccionan opciones de menú y añaden comentarios sobre alergias u otras necesidades; 4) Al confirmar, reciben un email automático de confirmación; 5) Tú recibes una notificación por cada nueva confirmación y puedes consultar en cualquier momento un panel donde se muestran todas las respuestas organizadas en una tabla. El sistema Premium permite además opciones avanzadas como: asignación de mesas, grupos de invitados (familia, amigos, trabajo), estadísticas de confirmaciones, y exportación de datos a Excel. Según nuestra experiencia, este sistema tiene una tasa de respuesta del 95%, mucho mayor que las confirmaciones telefónicas tradicionales, y ahorra a las parejas unas 15-20 horas de llamadas y mensajes de seguimiento.",
      category: "Funcionalidades"
    },
    {
      question: "¿Cuánto tiempo estará activa la web después de la boda?",
      answer: "La web de boda permanecerá activa durante el periodo incluido en tu plan: 1 año para el plan Básico, 2 años para el plan Premium, y 5 años para el plan Deluxe. Durante este tiempo, la web funcionará exactamente igual que antes de la boda, permitiendo que tanto vosotros como vuestros invitados accedáis a los recuerdos, fotos y momentos compartidos. Una vez finalizado el periodo incluido, tienes varias opciones: 1) Renovar el alojamiento por periodos adicionales (30€/año); 2) Recibir una copia completa de la web para guardarla como recuerdo; 3) Convertirla en un sitio estático de menor coste (15€/año). Muchas parejas deciden mantener la web activa como recuerdo digital o incluso la transforman en un blog familiar para compartir momentos importantes después de la boda. Si deseas cancelar la web antes del periodo contratado, podemos proporcionarte todos los contenidos en formato digital para que no pierdas ningún recuerdo.",
      category: "Mantenimiento"
    },
    {
      question: "¿Cómo funciona la galería colaborativa de fotos?",
      answer: "La galería colaborativa es una de las funcionalidades más valoradas por nuestros clientes y funciona así: 1) Los invitados acceden a la sección de galería en la web; 2) Pueden subir fotos directamente desde su móvil u ordenador con un proceso muy sencillo (no requiere crear cuentas ni instalar apps); 3) Las fotos se almacenan en álbumes organizados que puedes personalizar (preboda, ceremonia, celebración, etc.); 4) Existe moderación opcional para que podáis aprobar las fotos antes de que sean visibles para todos; 5) Los invitados pueden descargar las imágenes en alta calidad o compartirlas directamente en redes sociales; 6) Después de la boda, podéis descargar todas las fotos en un solo archivo comprimido. Esta funcionalidad complementa perfectamente el trabajo del fotógrafo profesional, ya que captura momentos espontáneos desde múltiples ángulos. En promedio, nuestras parejas reciben entre 200-500 fotos adicionales a través de este sistema, creando un álbum colectivo único con perspectivas que el fotógrafo no podría capturar. La capacidad estándar es de 1GB (aproximadamente 500-700 fotos), ampliable si es necesario.",
      category: "Funcionalidades"
    }
  ];

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para web de bodas
      pageTitle="Web para Bodas desde 99€ | Invitaciones Digitales que Ahorran Tiempo y Dinero"
      pageDescription="Crea tu página web para invitaciones de boda. Ahorra en invitaciones tradicionales, confirmaciones automáticas y galería de fotos colaborativa. Tu boda más organizada."
      pageKeywords="web para bodas, invitación de boda digital, página web barata boda, web de boda económica, invitaciones online boda"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-bodas"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para bodas desde 99€ (ahorra en invitaciones tradicionales)"
      heroSubtitle="Invitaciones digitales elegantes y prácticas. Información centralizada, confirmaciones automáticas y galería de fotos colaborativa. Tu boda más organizada con menos estrés."
      heroImage="/servicios/tipo-cliente/hero-bodas.webp"
      badges={['Desde 99€ (pago único)', 'Entrega en 3-5 días', 'Ahorra +800€ en invitaciones', 'Dominio incluido']}
      heroCTAText="Reservar ahora"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para todas las parejas"
      pricingSubtitle="Elige el plan que mejor se adapte a vuestras necesidades. Todos incluyen diseño personalizado y dominio propio."
      plans={plans}
      
      featuresTitle="¿Por qué nuestra web de bodas es perfecta para vosotros?"
      features={features}
      
      processTitle="Vuestra web de boda en 3 sencillos pasos"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué elegirnos para crear vuestra web de boda?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="Beneficios de una web para vuestra boda"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs de boda"
      faqCategories={["Ventajas", "Plazos", "Proceso", "Funcionalidades", "Mantenimiento"]}
      faqs={faqs}
      
      ctaTitle="¿Listos para facilitar la organización de vuestra boda?"
      ctaDescription="Cread vuestra web de boda en menos de una semana. Ahorrad tiempo, dinero y estrés con una invitación digital elegante y práctica."
      ctaButtonText="Reservar consulta gratuita"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebBodasPage; 

